import apiClient from '../apiClient';

const normalizeStatus = (status) => {
  if (!status) {
    return 'screening';
  }

  const normalized = String(status).trim().toLowerCase();
  return normalized.replace(/\s+/g, '-');
};

const normalizeApplication = (application) => ({
  id: application?.id ?? application?._id ?? application?.applicationNumber,
  applicationNumber: application?.applicationNumber ?? application?.id,
  fullName: application?.fullName ?? application?.name ?? '',
  positionId: application?.positionId ?? '',
  positionTitle: application?.positionTitle ?? application?.positionId ?? '',
  locationId: application?.locationId ?? '',
  locationName: application?.locationName ?? '',
  status: normalizeStatus(application?.status),
  appliedAt: application?.appliedAt ?? null,
  interviewDate: application?.interviewDate ?? application?.metadata?.interviewDate ?? null,
  experienceSummary: application?.experienceSummary ?? application?.notes ?? null,
  coverLetter: application?.coverLetter ?? null,
  phone: application?.phone ?? null,
  email: application?.email ?? null,
  preferredContactMethod: application?.preferredContactMethod ?? null,
  internalNotes: application?.internalNotes ?? null,
  metadata: application?.metadata ?? {},
});

export const fetchJobApplications = async (params = {}) => {
  const response = await apiClient.get('/job-applications', { params });
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeApplication);
};

export const createJobApplication = async (payload) => {
  const response = await apiClient.post('/job-applications', payload);
  return normalizeApplication(response?.data ?? {});
};

export const updateJobApplicationStatus = async (id, status, internalNotes) => {
  const response = await apiClient.patch(`/job-applications/${id}/status`, {
    status,
    internalNotes,
  });

  return normalizeApplication(response?.data ?? {});
};

export default {
  fetchJobApplications,
  createJobApplication,
  updateJobApplicationStatus,
};
